import type { ReactNode } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import NestableClickableListItem from 'LuxKit/List/NestableClickableListItem'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'

const Row = styled(NestableClickableListItem)`
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${props => props.theme.borderRadius.M};
  &.size-medium { padding: ${rem(12)} ${rem(16)}; }
`

const BookingLink = styled(TextLink)`
  flex-shrink: 0;
  white-space: nowrap;
`

interface Props {
  name: string
  dayOfStay?: number
  totalDays?: number
  bookingHref?: string
  actions: ReactNode
  onClick: () => void
}

function BookedAccommodationDayRow({ name, dayOfStay, totalDays, bookingHref, actions, onClick }: Props) {
  const intl = useIntl()
  return (
    <Row
      size="medium"
      title={<>
        {name}
        {!!dayOfStay && !!totalDays && <>{' '}
          <BodyText as="span" variant="medium" weight="normal" colour="light-foreground-alt">
            {intl.formatMessage({
              id: 'e8ixUo_xKNbLCTt4ZRPL',
              defaultMessage: 'Day {day} of {total}',
              description: 'Progress through a booked hotel stay shown in the daily trip itinerary',
            }, { day: dayOfStay, total: totalDays })}
          </BodyText>
        </>}
      </>}
      titleWeight="bold"
      onClick={onClick}
      startIcon={<LineBedIcon size="S" />}
      endIcon={actions}
    >
      {bookingHref && <BookingLink size="medium" href={bookingHref} target="_blank" rel="noopener noreferrer">
        {intl.formatMessage({
          id: 'V3if7yCh9Y75j9TcYdbF',
          defaultMessage: 'Booking details',
          description: 'CTA button text to view booking details in trip planner',
        })}
      </BookingLink>}
    </Row>
  )
}

export default BookedAccommodationDayRow
